import { activeStates } from './constants';

/** Which gl-draw features render as active (fully visible) during a draw mode. */
export function featureDrawActiveState(
  featureId: string | number | undefined,
  primaryId: string | number | undefined,
  keepVisibleFeatureIds?: Array<string | number>
): string {
  const id = String(featureId ?? '');
  if (primaryId != null && id === String(primaryId)) return activeStates.ACTIVE;
  if (keepVisibleFeatureIds?.some((k) => String(k) === id)) {
    return activeStates.ACTIVE;
  }
  return activeStates.INACTIVE;
}
